// Copyright 2024 Sadiant Inc. All Rights Reserved. This software is subject to a license agreement. Unauthorized or unlicensed use is prohibited.
import { Injectable } from '@angular/core';
import { NavigationStart } from '@angular/router';
import { isHTMLElement } from '@sadiant/type-guards';
import { DynamicDialogRef } from 'primeng/dynamicdialog';

@Injectable({ providedIn: 'root' })
export class DialogHelperService {
  private openDialogRefs: DynamicDialogRef[] = [];

  constructor() {}

  addOpenDialogRef(dialogRef: DynamicDialogRef) {
    // 🔹 Instead of closing all, just track multiple dialogs
    this.openDialogRefs.push(dialogRef);
    this.blurButtonThatOpenedDialog();
  }

  closeWhenBrowserArroyNavigation(item: NavigationStart): void {
    if (item.navigationTrigger === 'popstate') {
      this.closeAllDialogs();
    }
  }

  closeAllDialogs(): void {
    this.openDialogRefs.forEach(dialogRef => dialogRef.close());
    this.openDialogRefs = [];
  }

  closeAdobeDialogOnly(): void {
    if (this.openDialogRefs.length > 1) {
      const adobeDialog = this.openDialogRefs.pop(); // Close the last opened dialog (Adobe)
      adobeDialog?.close();
    }
  }

  private blurButtonThatOpenedDialog(): void {
    var element = document?.activeElement;
    if (isHTMLElement(element)) {
      element.blur();
    }
  }
}
